<ion-page>
  <ion-content class="fade-slide-enter">
    <div class="page-shell">
      <div class="page-content">
        <div class="layout">
          <app-back-button></app-back-button>

          <div class="page-header">
            <h1 class="page-title">Terms of Service</h1>
            <p class="subtitle">Last updated: December 2025</p>
          </div>

          <div class="glass-card terms-card">
            <section>
              <p>
                These Terms of Service (“Terms”) govern your access to and use of Tubify (“Tubify”, “the Service”), owned and operated by:
              </p>
              <p>
                Miguel Bautista Pérez<br />
                José Bergamín 40, Madrid, Spain<br />
                Email: <a href="mailto:support@tubify.eu">support@tubify.eu</a>
              </p>
              <p>By accessing or using Tubify, you agree to be bound by:</p>
              <ul>
                <li>These Terms of Service</li>
                <li>Our Privacy Policy: <a href="https://tubify.eu/privacy" target="_blank" rel="noopener">https://tubify.eu/privacy</a></li>
                <li>YouTube Terms of Service: <a href="https://www.youtube.com/t/terms" target="_blank" rel="noopener">https://www.youtube.com/t/terms</a></li>
                <li>Google Privacy Policy: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">https://policies.google.com/privacy</a></li>
                <li>Spotify Terms of Use: <a href="https://www.spotify.com/legal/end-user-agreement/" target="_blank" rel="noopener">https://www.spotify.com/legal/end-user-agreement</a></li>
                <li>Spotify Privacy Policy: <a href="https://www.spotify.com/legal/privacy-policy/" target="_blank" rel="noopener">https://www.spotify.com/legal/privacy-policy</a></li>
              </ul>
              <p>If you do not agree, you must stop using Tubify.</p>
            </section>

            <section>
              <h3>1. Description of the Service</h3>
              <p>
                Tubify is an online platform that allows users to convert playlists between Spotify and YouTube / YouTube Music by processing permitted metadata.
              </p>
              <p>Tubify does not:</p>
              <ul>
                <li>Download, store, or redistribute audiovisual content</li>
                <li>Provide video or audio download functionality</li>
                <li>Bypass or circumvent YouTube or Spotify technical restrictions</li>
              </ul>
              <p>Tubify may display advertising unless you have purchased a premium subscription.</p>
              <p>Conversion accuracy is not guaranteed.</p>
            </section>

            <section>
              <h3>2. Relationship with YouTube and Google</h3>
              <p>Tubify uses YouTube API Services to:</p>
              <ul>
                <li>Search for YouTube videos</li>
                <li>Retrieve video and playlist metadata</li>
                <li>Create or modify playlists on your YouTube or YouTube Music account</li>
              </ul>
              <p>Tubify is not endorsed, certified, or sponsored by Google LLC or YouTube.</p>
              <p>By using Tubify, you agree to be bound by:</p>
              <ul>
                <li>YouTube Terms of Service - <a href="https://www.youtube.com/t/terms" target="_blank" rel="noopener">https://www.youtube.com/t/terms</a></li>
                <li>Google Privacy Policy - <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">https://policies.google.com/privacy</a></li>
              </ul>
              <p>You may revoke Tubify’s access at any time: <a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener">https://myaccount.google.com/permissions</a></p>

              <h4>2.1 Compliance with Google API Services User Data Policy — Limited Use</h4>
              <p>Tubify’s use and transfer of information received from Google APIs complies with the Google API Services User Data Policy, including the Limited Use requirements.</p>
              <ul>
                <li>Tubify only uses YouTube API Data to provide or improve user-facing features.</li>
                <li>Tubify does not use YouTube API Data for advertising, marketing, or profiling.</li>
                <li>Tubify does not sell or monetize YouTube API Data.</li>
                <li>Tubify does not transfer YouTube API Data to third parties except as required to provide the Service or by law.</li>
                <li>Human access to YouTube API Data is restricted unless you give explicit consent, it is necessary for fraud prevention or security, required by law, or required for debugging under strict controls.</li>
              </ul>
            </section>

            <section>
              <h3>3. Relationship with Spotify</h3>
              <p>Tubify uses the Spotify Web API to:</p>
              <ul>
                <li>Retrieve playlist and track metadata</li>
                <li>Identify potential matches for conversion</li>
                <li>Create playlists in your Spotify account</li>
              </ul>
              <p>Tubify is not affiliated with, endorsed, or sponsored by Spotify AB.</p>
              <p>By using Tubify, you agree to be bound by:</p>
              <ul>
                <li>Spotify Terms of Use - <a href="https://www.spotify.com/legal/end-user-agreement/" target="_blank" rel="noopener">https://www.spotify.com/legal/end-user-agreement</a></li>
                <li>Spotify Privacy Policy - <a href="https://www.spotify.com/legal/privacy-policy/" target="_blank" rel="noopener">https://www.spotify.com/legal/privacy-policy</a></li>
              </ul>
              <p>You may revoke access at any time: <a href="https://www.spotify.com/account/apps/" target="_blank" rel="noopener">https://www.spotify.com/account/apps/</a></p>

              <h4>3.1 Compliance with Spotify Developer Terms</h4>
              <ul>
                <li>Tubify does not use Spotify Data for advertising or targeting.</li>
                <li>Tubify does not sell or monetize Spotify Data.</li>
                <li>Tubify does not transfer Spotify Data to advertisers or unrelated parties.</li>
              </ul>
            </section>

            <section>
              <h3>4. Eligibility</h3>
              <p>To use Tubify, you must:</p>
              <ul>
                <li>Be at least 16 years old</li>
                <li>Have the legal right to connect your YouTube and/or Spotify account via OAuth</li>
                <li>If acting for an organization, have authority to bind it to these Terms</li>
              </ul>
            </section>

            <section>
              <h3>5. User Accounts</h3>
              <p>
                Some features require account creation. You agree to provide accurate information, safeguard your password, and be responsible for all actions under your account.
                We may suspend or delete accounts that violate these Terms or platform policies.
              </p>
            </section>

            <section>
              <h3>6. OAuth Authorization and Revocation</h3>
              <p>
                Connecting your YouTube or Spotify account authorizes Tubify to access the minimum data needed to provide the Service.
              </p>
              <p>Revocation links:</p>
              <ul>
                <li>Google / YouTube: <a href="https://myaccount.google.com/permissions" target="_blank" rel="noopener">https://myaccount.google.com/permissions</a></li>
                <li>Spotify: <a href="https://www.spotify.com/account/apps/" target="_blank" rel="noopener">https://www.spotify.com/account/apps/</a></li>
              </ul>
              <p>
                After revocation Tubify immediately loses access, OAuth tokens are deleted as described in our Privacy Policy, and some functionality will stop working.
              </p>
            </section>

            <section>
              <h3>7. Acceptable Use Policy</h3>
              <p>You agree not to:</p>
              <ol>
                <li>Download, copy, store, or redistribute YouTube audiovisual content.</li>
                <li>Download, copy, or redistribute YouTube audiovisual content.</li>
                <li>Use Tubify to bypass YouTube or Spotify terms, quotas, or rate limits.</li>
                <li>Automate usage through bots, scripts, or scraping tools.</li>
                <li>Interfere with security, servers, or API infrastructure.</li>
                <li>Perform high-volume or automated playlist migrations that risk exceeding API quotas.</li>
                <li>Reverse engineer, decompile, or modify Tubify.</li>
                <li>Use Tubify in violation of YouTube, Google, or Spotify policies.</li>
                <li>Engage in fraudulent, abusive, or unlawful activities.</li>
              </ol>
              <p>Violations may result in account suspension, termination, or reporting to platform providers.</p>
            </section>

            <section>
              <h3>8. Premium Subscription</h3>
              <p>Premium features may include ad-free usage and enhanced performance or features.</p>
              <p>Pricing:</p>
              <ul>
                <li>Monthly: €1</li>
                <li>Yearly: €9</li>
              </ul>

              <h4>8.1 Right of Withdrawal</h4>
              <p>
                You have a 14-day withdrawal right unless you agree to immediate service delivery. By purchasing a premium subscription, you may choose to have premium features activated immediately.
Once premium features are activated you acknowledge that the 14-day withdrawal right is waived.
              </p>

              <h4>8.2 Refunds</h4>
              <p>Payments are non-refundable except where required by EU consumer law.</p>
            </section>

            <section>
              <h3>9. Advertisements</h3>
              <p>
                Tubify may display third-party advertisements (e.g., via Adsterra) in the free version. Tubify does not control ad content, external websites reached via ads, or the privacy practices of
                advertisers. See the Privacy Policy for details.
              </p>
            </section>

            <section>
              <h3>10. Data Processing</h3>
              <p>
                Tubify processes data according to the Privacy Policy: <a href="https://tubify.eu/privacy" target="_blank" rel="noopener">https://tubify.eu/privacy</a>. The Privacy Policy describes
                data collected, legal bases, retention, cookie/advertising practices, deletion, OAuth revocation, and international transfers. If you disagree with the Privacy Policy, you must stop using Tubify.
              </p>
            </section>

            <section>
              <h3>11. Intellectual Property</h3>
              <p>
                Tubify does not claim ownership of YouTube content, Spotify content, or your playlists/metadata. You retain ownership of your playlists and inputs.
              </p>
            </section>

            <section>
              <h3>12. Copyright Policy</h3>
              <p>Tubify does not host audiovisual content but respects intellectual property rights.</p>
              <p>
                To submit a copyright notice:<br />
                Email: <a href="mailto:support@tubify.eu">support@tubify.eu</a><br />
                Subject: “Copyright Complaint”
              </p>
            </section>

            <section>
              <h3>13. Service Availability and API Dependency</h3>
              <p>
                Tubify relies on YouTube and Spotify APIs. We do not guarantee continuous availability. Functionality may be limited due to API outages or policy changes, quota exhaustion,
                technical maintenance, or compliance requirements. Conversion accuracy is not guaranteed.
              </p>
            </section>

            <section>
              <h3>14. Service Modifications</h3>
              <p>
                We may modify, update, or discontinue the Service or its features. Where legally required, we will request renewed consent for material changes.
              </p>
            </section>

            <section>
              <h3>15. Limitation of Liability</h3>
              <p>
                To the fullest extent permitted by law, Tubify is not liable for loss of playlists or metadata, incorrect matches or failed conversions, API outages, quota limits, or provider errors,
                indirect or consequential damages, financial or data loss, or service downtime or termination. Use of Tubify is at your own risk.
              </p>
            </section>

            <section>
              <h3>16. Indemnification</h3>
              <p>
                You agree to indemnify Tubify and its owner against claims arising from your misuse of the Service, violations of these Terms, violations of YouTube, Google, or Spotify policies,
                or infringement of third-party rights.
              </p>
            </section>

            <section>
              <h3>17. Termination</h3>
              <p>
                We may suspend or terminate your access if you violate these Terms, if required by law or platform providers, or if you pose a security or compliance risk. OAuth tokens and account data
                are deleted per our Privacy Policy.
              </p>
            </section>

            <section>
              <h3>18. Changes to These Terms</h3>
              <p>We may update these Terms for legal, technical, or service reasons. Continued use after updates constitutes acceptance of the revised Terms.</p>
            </section>

            <section>
              <h3>19. Severability</h3>
              <p>If any provision is invalid, remaining provisions remain effective.</p>
            </section>

            <section>
              <h3>20. Governing Law</h3>
              <p>These Terms are governed by Spanish law and applicable EU law (including GDPR). Disputes will be resolved in Madrid, Spain.</p>
            </section>

            <section>
              <h3>21. Contact Information</h3>
              <p>
                For legal inquiries or support:<br />
                Email: <a href="mailto:support@tubify.eu">support@tubify.eu</a><br />
                Owner: Miguel Bautista Pérez<br />
                Address: José Bergamín 40, Madrid, Spain
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  </ion-content>
</ion-page>
